import type { DocumentAuditTrailModel } from "@/api/cle-api";

import { AuditTrailTimelineItem } from "./AuditTrailTimelineItem";

interface AuditTrailTimelineProps {
  events: DocumentAuditTrailModel[];
}

export const AuditTrailTimeline = ({ events }: AuditTrailTimelineProps) => (
  <ul className="audit-trail list-unstyled mb-0">
    {events.map((item, index) => (
      <AuditTrailTimelineItem
        isLast={index === events.length - 1}
        item={item}
        key={String(item.id ?? `${item.createdAt}-${item.action}-${index}`)}
      />
    ))}
  </ul>
);
